import { FC, memo } from 'react';
import { Box } from '@material-ui/core';
import { Skeleton } from '@material-ui/lab';
import { InfovViewImageContainer, MainCarImage } from './InfoViewImageItem.styles';
import useImageLoader from 'shared/hooks/useImageLoader';

type InfoViewImageItemProps = {
  image_url: string;
  index: number;
};

const InfoViewImageItem: FC<InfoViewImageItemProps> = ({ image_url, index }) => {
  const { imageLoaded, error } = useImageLoader(image_url);
  return (
    <InfovViewImageContainer key={index}>
      <Box style={{ width: '100%' }}>
        {imageLoaded && !error ? (
          <MainCarImage src={image_url} alt="Car" loading="lazy" />
        ) : (
          <Skeleton
            variant="rect"
            style={{ aspectRatio: '16/9', width: '100%', height: 'auto', borderRadius: '8px' }}
          />
        )}
      </Box>
    </InfovViewImageContainer>
  );
};

export default memo(InfoViewImageItem);
